import React from 'react';
// Images
import PhoneImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-full-body.png';
import HalfPhoneImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-full-body-small.png';
// Constants
import {
  CompanyName,
  ContactEmailAddress,
} from '../../utils/Constants';
import {
  QUESTIONNAIRE_PAGE_URL,
  SERVICES_PAGE_URL,
} from '../../utils/Routes';
// Components
import ContactCard from '../contact/ContactCard';

function ContactInfoSection() {
  return (
    <section className='grid px-2 sm:px-8 md:px-10 text-colour7'>
      <div className='grid lg:container mx-auto bg-colour5 shadow-cardShadow py-6 md:py-10 lg:py-16'>
        <article className='grid gap-4 mx-auto text-center px-6 s:px-8 md:px-12 lg:mx-auto'>
          {/* Notes */}
          <div className='bg-colour2 w-full lg:w-fit mx-auto px-4 py-4 lg:py-5 lg:px-12 xl:px-16 shadow-cardShadow'>
            <h3 className='text-colour1 text-3xl md:text-4xl lg:text-5xl xl:text-6xl mb-1 font-semibold font-titleFont'>
              Contact Me
            </h3>
            <p className='text-lg'>
              A well-written email is far better than a nervous phone call.
            </p>
          </div>

          {/* Contact info */}
          <ContactCard />

          {/* Phone image */}
          <section className='lg:hidden mx-auto'>
            <img src={HalfPhoneImage} alt={`Contact ${CompanyName}`} />
          </section>

          <section className='grid gap-4'>
            {/* image Large screen container */}
            <div className='grid lg:grid-cols-reg gap-4 lg:gap-2 lg:pr-4 lg:my-10'>
              <section className='hidden lg:block my-6'>
                <img
                  src={PhoneImage}
                  alt={`Contact ${CompanyName}`}
                  className='lg:max-h-[70vh]'
                />
              </section>
              <section className='grid gap-4'>
                <div className='pb-2'>
                  <p className='mt-6'>
                    <strong>Before</strong> you reach out to enquire, read My{' '}
                    <a
                      href={SERVICES_PAGE_URL}
                      className='text-colour1 italic'
                      title='Click to navigate to page'
                    >
                      “Services”
                    </a>{' '}
                    tab and ensure you include all the necessary information in
                    your submission application form. The more information
                    provided, the better, so I can ensure to plan and tailor the
                    session plan to your every kinky desire. The 2 requirements
                    that are nonnegotiable to book with Me are:
                  </p>
                </div>
                <ul className='font-bold grid bg-colour4 shadow-cardShadow py-2 text-colour1'>
                  <li>ID (Age Verification)</li>
                  <li>Phone Number</li>
                </ul>

                <section className='grid' title='Click to fill out form'>
                  <a
                    href={QUESTIONNAIRE_PAGE_URL}
                    target='_blank'
                    rel='noreferrer'
                    className='bg-colour6 text-colour1 shadow-cardShadow py-1'
                    title='Click to fill out form'
                    aria-label={`Fill out submissive application form for ${CompanyName}`}
                  >
                    Fill out My Submissives Application Form
                  </a>
                </section>

                <section className='py-2'>
                  <p>
                    These requirements are kept private and confidential
                    indefinitely. If you are not comfortable with sending either
                    of these, I am not the Domina for you. <strong>ANY</strong>{' '}
                    attempts at negotiation will result in a block.{' '}
                    <strong>ANY</strong> enquiries received without these
                    requirements will be ignored till they are sent.{' '}
                  </p>
                  <p>
                    Email and Text/Whatsapp are My preferred methods of contact.
                    <strong>ANY</strong> phone calls received will result in
                    being blocked and the number reported.{' '}
                  </p>
                  <p>
                    I am not always available to take phone calls, so email is
                    my preferred method of contact.{' '}
                    <strong>I do not return calls</strong> out of respect for
                    your privacy, and I will <strong>never</strong> answer
                    withheld numbers.
                  </p>
                  <p>
                    If a phone conversation is necessary, I will arrange one{' '}
                    <strong>only after</strong> receiving an initial email and
                    $40 tribute fee—where you should have outlined your request{' '}
                    <em>properly</em> in the first place. Naughty boy.
                  </p>
                </section>

                <aside className='grid bg-colour4 shadow-cardShadow py-2 px-2'>
                  <p className='text-colour1'>
                    <strong>
                      When reaching out, I expect respect, politeness, and
                      clarity.
                    </strong>
                  </p>
                </aside>
              </section>
            </div>

            {/* Contact card */}
            <ContactCard />

            {/* Contact Information */}
            <section className='text-center hidden sm:block'>
              {/* Non-clickable Email & Phone (Visible on Desktop) */}

              {/* Clickable Email & Phone (Visible on Mobile) */}
              <section className='grid gap-4'>
                <div>
                  <p className='block sm:hidden'>
                    <strong className='text-colour1'>EMAIL: </strong>
                    <a href='mailto:{ContactEmailAddress}?subject=Session Booking Enquiry'>
                      {ContactEmailAddress}
                    </a>
                  </p>
                </div>

                <div>
                  <p className='italic'>
                    Quote your email with “Session Booking Enquiry”
                  </p>
                </div>
              </section>
            </section>
          </section>
        </article>
      </div>
    </section>
  );
}

export default ContactInfoSection;
